import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { ActionReducerMap, StoreModule } from "@ngrx/store";

import { AamsRegistrationEffect } from "./registration/aams/aams-registration.effect";
import { AddressEffect } from "./registration/address/address.effect";
import { addressReducer } from "./registration/address/address.reducer";
import { RegistrationWithBankIdEffect } from "./registration/bank-id/registration-with-bank-id.effect";
import { registrationWithBankIdReducer } from "./registration/bank-id/registration-with-bank-id.reducer";
import { RegistrationWithCepEffect } from "./registration/cep/registration-with-cep.effect";
import { registrationWithCepReducer } from "./registration/cep/registration-with-cep.reducer";
import { DataLookUpLevelEffect } from "./registration/data-lookup-level/data-lookup-level.effect";
import { dataLookupLevelReducer } from "./registration/data-lookup-level/data-lookup-level.reducer";
import { DgaRegistrationEffect } from "./registration/dga/dga-registration.effect";
import { dgaRegistrationReducer } from "./registration/dga/dga-registration.reducer";
import { RegistrationWithIdinEffect } from "./registration/idin/registration-with-idin.effect";
import { registrationWithIdinReducer } from "./registration/idin/registration-with-idin.reducer";
import { RegistrationWithPersonalNumberEffect } from "./registration/personal-number/registration-with-personal-number.effect";
import { registrationWithPersonalNumberReducer } from "./registration/personal-number/registration-with-personal-number.reducer";
import { RegistrationEffect } from "./registration/registration.effect";
import { registrationReducer } from "./registration/registration.reducer";
import { SmartIdRegistrationEffect } from "./registration/smart-id/registration-with-smart-id.effect";
import { RegistrationWithSPIDEffect } from "./registration/spid/registration-with-spid.effect";
import { registrationWithSPIDReducer } from "./registration/spid/registration-with-spid.reducer";
import { SeamlessRegistrationEffect } from "./seamless-registration/seamless-registration.effect";
import { seamlessRegistrationReducer } from "./seamless-registration/seamless-registration.reducer";
import { RegistrationFeatureState } from "./state";
import { DgaRegistrationTelemetryEffect } from "./telemetry/dga-registration-telemetry.effect";
import { RegistrationTelemetryEffect } from "./telemetry/registration-telemetry.effect";
import { RegistrationWithPersonalNumberTelemetryEffect } from "./telemetry/registration-with-personal-number-telemetry.effect";
import { SeamlessRegistrationTelemetryEffect } from "./telemetry/seamless-registration/seamless-registration-telemetry.effect";

export const REGISTRATION_FEATURE_REDUCER: ActionReducerMap<RegistrationFeatureState["registrationFeature"]> = {
	registration: registrationReducer,
	dgaRegistration: dgaRegistrationReducer,
	registrationWithPersonalNumber: registrationWithPersonalNumberReducer,
	seamlessRegistration: seamlessRegistrationReducer,
	dataLookupLevel: dataLookupLevelReducer,
	registrationWithIdin: registrationWithIdinReducer,
	registrationWithBankId: registrationWithBankIdReducer,
	registrationWithSPID: registrationWithSPIDReducer,
	registrationWithCep: registrationWithCepReducer,
	address: addressReducer,
};

@NgModule({
	imports: [
		EffectsModule.forFeature([
			AamsRegistrationEffect,
			DgaRegistrationEffect,
			DgaRegistrationTelemetryEffect,
			RegistrationEffect,
			RegistrationTelemetryEffect,
			RegistrationWithPersonalNumberEffect,
			RegistrationWithIdinEffect,
			RegistrationWithBankIdEffect,
			RegistrationWithSPIDEffect,
			SmartIdRegistrationEffect,
			DataLookUpLevelEffect,
			RegistrationWithPersonalNumberTelemetryEffect,
			SeamlessRegistrationEffect,
			SeamlessRegistrationTelemetryEffect,
			RegistrationWithCepEffect,
			AddressEffect,
		]),
		StoreModule.forFeature("registrationFeature", REGISTRATION_FEATURE_REDUCER),
	],
})
export class CommonRegistrationSdkModule {}
